import { render, staticRenderFns } from "./PostTags.vue?vue&type=template&id=5df57b64&"
import script from "./PostTags.vue?vue&type=script&lang=js&"
export * from "./PostTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports